"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterResponsePayloadToJSON = exports.RegisterResponsePayloadFromJSONTyped = exports.RegisterResponsePayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function RegisterResponsePayloadFromJSON(json) {
    return RegisterResponsePayloadFromJSONTyped(json, false);
}
exports.RegisterResponsePayloadFromJSON = RegisterResponsePayloadFromJSON;
function RegisterResponsePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customer': !(0, runtime_1.exists)(json, 'customer') ? undefined : (0, _1.CustomerDataFromJSON)(json['customer']),
        'tokens': !(0, runtime_1.exists)(json, 'tokens') ? undefined : (0, _1.TokensFromJSON)(json['tokens']),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
        'inlineErrors': !(0, runtime_1.exists)(json, 'inlineErrors') ? undefined : (0, _1.AddressInlineErrorMessagesFromJSON)(json['inlineErrors']),
        'addressOptions': !(0, runtime_1.exists)(json, 'addressOptions') ? undefined : (json['addressOptions'].map(_1.AddressOnlyFromJSON)),
    };
}
exports.RegisterResponsePayloadFromJSONTyped = RegisterResponsePayloadFromJSONTyped;
function RegisterResponsePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customer': (0, _1.CustomerDataToJSON)(value.customer),
        'tokens': (0, _1.TokensToJSON)(value.tokens),
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
        'inlineErrors': (0, _1.AddressInlineErrorMessagesToJSON)(value.inlineErrors),
        'addressOptions': value.addressOptions === undefined ? undefined : (value.addressOptions.map(_1.AddressOnlyToJSON)),
    };
}
exports.RegisterResponsePayloadToJSON = RegisterResponsePayloadToJSON;
//# sourceMappingURL=RegisterResponsePayload.js.map